import { useCallback } from 'react';

/**
 * Custom hook to measure text width using a hidden element
 */
export const useTextMeasurement = hiddenTextRef => {
  /**
   * Measures the width of a text string using the hidden reference element
   */
  const measureTextWidth = useCallback(text => {
    if (!hiddenTextRef.current) {
      return 0;
    }
    hiddenTextRef.current.textContent = text;
    return hiddenTextRef.current.getBoundingClientRect().width;
  }, [hiddenTextRef]);
  return {
    measureTextWidth
  };
};
export default useTextMeasurement;
//# sourceMappingURL=useTextMeasurement.js.map